<template>
    <section class="b-comment-item">
        <div class="b-comment-item__heading">
          <div class="b-comment-item__user b-comment-item-user">
            <figure class="b-comment-item-user__avatar">
              <img :src="comment.user.avatar" v-if="comment.user.avatar">
              <svg viewBox="0 0 40 40" v-else>
                <use xlink:href="/assets/site/images/sprites.svg?ver=19#sprite-user"></use>
              </svg>
            </figure>
            <section class="b-comment-item-user__content">
              <h5 class="b-comment-item-user__name">
                {{comment.user.name}}
              </h5>
              <div class="b-comment-item-user__rating"
                   v-if="(comment.rating)  && (comment.parent_id === 0)"
                  >
                <star-rating
                    :star-size="24"
                    :show-rating="false"
                    :read-only="true"
                    :rating="comment.rating.value"
                    active-color="#FDC20B"
                    inactive-color="rgba(253, 194, 11, 0.3)"
                    :round-start-rating="false"
                    v-if="comment.rating.value > 0"
                ></star-rating>
              </div>
            </section>
          </div>
            <span class="b-comment-item__datetime">
                {{comment.created_at}}
            </span>

        </div>
        <div class="b-comment-item__text" v-html="comment.comment"></div>
      <div class="mt-2 mb-2" v-if="comment.images.length > 0">
        <a data-fancybox="comment_gallery" :href="image.url" v-for="image in comment.images" style="display:inline-block; margin: 10px; width: 120px; height: 120px;">
          <img  :src="image.thumb" >
        </a>

      </div>
      <div class="b-comment-item__footer">
        <button class="btn b-comment-item__answer" @click.prevent="answerComment(comment.id)">
          <svg viewBox="0 0 40 40">
            <use xlink:href="/assets/site/images/sprites.svg?ver=199#sprite-answer"></use>
          </svg>
          Ответить
        </button>
        <div class="b-comment-item__social">
          <span class="b-comment-item__social-text">
             Полезный отзыв?
          </span>

          <span class="b-comment-item__social-btn b-comment-item__social-btn--like" @click.prevent="likeOrDislike('like')">
            <svg viewBox="0 0 40 40">
              <use xlink:href="/assets/site/images/sprites.svg?ver=199#sprite-like"></use>
            </svg>
            {{comment.like}}
          </span>
          <span class="b-comment-item__social-btn b-comment-item__social-btn--dislike" @click.prevent="likeOrDislike('dislike')">
            <svg viewBox="0 0 40 40">
              <use xlink:href="/assets/site/images/sprites.svg?ver=199#sprite-dislike"></use>
            </svg>
            {{comment.dislike}}
            </span>
        </div>
      </div>

      <div class="b-comment-item__border"></div>
      <section class="b-comment-item__answers" v-if="comment.children && comment.children.length">
          <comment v-on:answer-comment="answerComment" :key="child.id" v-for="(child, index) in comment.children" :comment="child"></comment>
      </section>
    </section>
</template>
<script>
    import { eventBus } from "../../../app";
    import LightBox from 'vue-image-lightbox'
    import StarRating from 'vue-star-rating'
    export default {
      name:"comment",
        components:{
            LightBox,StarRating
        },
        props:['comment','auth'],
        data(){
            return {
                media:[
                    {
                        thumb:this.comment.thumb,
                        src:this.comment.image
                    },
                ],
             clicked:"",
            }
        },
        methods: {
            openGallery(index) {
                this.$refs.lightbox.showImage(index)
            },
          likeOrDislike(type) {
              if(this.auth) {
                axios.post('/api/comment/like-or-dislike', {id:this.comment.id, type:type})
                    .then((response) => {
                      this.comment.like= response.data.like;
                      this.comment.dislike = response.data.dislike;
                    })
                    .catch((error => {

                    }))
              } else {
                this.$emit('show-auth-modal')
              }

          },
          answerComment(id) {

              this.$emit('answer-comment',id)
          }
        },
      created() {
        eventBus.$on('like-or-dislike', this.likeOrDislike);
      }
    }
</script>
